var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrugiCiklus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.125C16.875 18.4705 16.5952 18.75 16.25 18.75H5.625C3.21259 18.75 1.25 16.7871 1.25 14.375V3.75C1.25 3.40454 1.52985 3.125 1.875 3.125C2.22015 3.125 2.5 3.40454 2.5 3.75V14.375C2.5 16.098 3.90198 17.5 5.625 17.5H16.25C16.5952 17.5 16.875 17.7795 16.875 18.125ZM18.75 3.125V14.375C18.75 15.4089 17.9089 16.25 16.875 16.25H5.625C4.59106 16.25 3.75 15.4089 3.75 14.375V3.125C3.75 2.09106 4.59106 1.25 5.625 1.25H16.875C17.9089 1.25 18.75 2.09106 18.75 3.125ZM13.125 5.625C13.125 5.27954 12.8452 5 12.5 5H10C9.65485 5 9.375 5.27954 9.375 5.625C9.375 5.97046 9.65485 6.25 10 6.25H11.875V8.125H10C9.65485 8.125 9.375 8.40454 9.375 8.75V11.875C9.375 12.2205 9.65485 12.5 10 12.5H12.5C12.8452 12.5 13.125 12.2205 13.125 11.875C13.125 11.5295 12.8452 11.25 12.5 11.25H10.625V9.375H12.5C12.8452 9.375 13.125 9.09546 13.125 8.75V5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugiCiklus);
export default __webpack_public_path__ + "static/media/drugi-ciklus.7c1799abbbb373ed665d062da97834b0.svg";
export { ForwardRef as ReactComponent };